import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";

export const DivUserMenuContainer = styled.div`
  width: 200px;
  position: absolute;
  top: ${GLOBAL_NAVI_HEIGHT.PC}px;
  right: 0;
  background-color: ${COLOR.GRAY100.code};
  border-radius: 0 0 8px 8px;
  overflow: hidden;
`;
